var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clearfix img-box",style:({height:_vm.height})},[_c('img',{staticClass:"img",attrs:{"src":require('@/assets/img/'+_vm.img),"width":_vm.width,"height":_vm.height,"alt":""}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }